import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Modal } from "reactstrap";

import CustomProfileImage from "../../user/profile/CustomProfileImage";

const WebUserLoginResetAlertModal = ({ isModalOpened, selectedMemberInfo, toggleModalOpened, onClickResetUserStatus, alertKind, alertMessage }) => {
    const { t } = useTranslation();

    const [memberInfo, setMemberInfo] = useState(selectedMemberInfo);
    const [lAlertMessage, setAlertMessage] = useState(alertMessage);
    const [lAlertKind, setAlertKind] = useState(alertKind);

    useEffect(() => {
        setAlertKind(alertKind);
    }, [alertKind]);

    useEffect(() => {
        setAlertMessage(alertMessage);
    }, [alertMessage]);

    return (
        // 260805 web-light-modal: 전역 다크 테마 모달 스타일과 분리해 web 화면 톤(라이트)에 맞춤 - index.css의 --modal-* 변수를 라이트 값으로 재정의
        <Modal isOpen={isModalOpened} centered backdrop={true} className="web-light-modal">
            <div className="card container-fluid">
                <div className="card-body">
                    <div className="title-area text-center dark-grey-text">
                        <span>
                            {t("관리자_초기화_문구_1", { ns: "admin" })}<br />
                            {t("관리자_초기화_문구_2", { ns: "admin" })}<br />
                            {t("관리자_초기화_문구_3", { ns: "admin" })}
                        </span>
                    </div>
                    <div className="content-area dark-grey-text">
                        <span className="small mb-1">[{t("관리자_초기화_문구_4", { ns: "admin" })}]</span>
                        <div className="d-flex align-items-center justify-content-center area-80">
                            <div className="area-15 fit-content">
                                <CustomProfileImage url={memberInfo.profileImgUrl} style={{ width: '2rem', height: '2rem' }} alt={memberInfo.userNickname} />
                            </div>
                            {/* 260804 닉네임이 길 때 잘리지 않던 문제 수정 - admin-ellipsis-cell/text로 말줄임(...) 처리 */}
                            <div className="d-flex align-items-center justify-content-center admin-ellipsis-cell" style={{ flex: '1 1 auto' }}>
                                <span className="hiclass-text admin-ellipsis-text" title={memberInfo.userNickname}>
                                    <b>{memberInfo.userNickname}</b>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="d-flex justify-content-center my-2">
                        <button type="button" className="btn red white-text mr-1 py-1 px-2" onClick={() => onClickResetUserStatus(memberInfo.mode, memberInfo.subDomainSeq, memberInfo.userSeq)}>{t("예", { ns: "common" })}</button>
                        <button type="button" className="btn green white-text ml-1 py-1 px-2" onClick={() => toggleModalOpened(false)}>{t("아니오", { ns: "common" })}</button>
                    </div>
                </div>
            </div>
        </Modal>
    );
}

export default WebUserLoginResetAlertModal;